import { SortBy } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'

export const getSortBy = (param: string) => {
  switch (param) {
    case 'asc':
      return SortBy.Asc
    case 'desc':
      return SortBy.Desc
    case 'relevance':
      return SortBy.Relevance
    case 'alphabetical':
      return SortBy.Alphabetical
    case 'review_score':
      return SortBy.ReviewScore
    case 'sales':
    default:
      return SortBy.Sales
  }
}
